import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { style: {"margin-bottom":"15px"} }
const _hoisted_2 = {
  key: 0,
  style: {"display":"flex","gap":"10px","padding":"15px"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "",
  style: {"flex-grow":"1"}
}, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "cell"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Y ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" N ")
const _hoisted_7 = {
  key: 1,
  class: "cell"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Y ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" N ")
const _hoisted_10 = { class: "cell" }
const _hoisted_11 = { class: "cell" }
const _hoisted_12 = { class: "cell" }
const _hoisted_13 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_14 = { style: {"flex-grow":"1"} }
const _hoisted_15 = { class: "cell" }
const _hoisted_16 = { class: "cell" }
const _hoisted_17 = { class: "cell" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "cell" }
const _hoisted_20 = { class: "cell" }
const _hoisted_21 = { class: "cell" }
const _hoisted_22 = { class: "cell" }
const _hoisted_23 = { class: "cell" }
const _hoisted_24 = { class: "cell" }
const _hoisted_25 = { class: "cell" }
const _hoisted_26 = { class: "cell" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    ref: "visitorForm",
    class: "visitor-list",
    "label-position": "top",
    model: _ctx.model,
    disabled: _ctx.view
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (!_ctx.view)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              (_ctx.visitors && _ctx.visitors.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.trans("label.verification")) + " ", 1),
                    _createVNode(_component_el_button_group, { size: "small" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "success",
                          plain: "",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeAll('status', 5)))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_5
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_button, {
                          type: "danger",
                          plain: "",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeAll('status', 1)))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_6
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.visitors && _ctx.visitors.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.trans("label.alert")) + " ", 1),
                    _createVNode(_component_el_button_group, { size: "small" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "success",
                          plain: "",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeAll('alert', 1)))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_8
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_button, {
                          type: "danger",
                          plain: "",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeAll('alert', 0)))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_9
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("input", {
                  class: "import-file",
                  ref: "importFile",
                  type: "file",
                  accept: ".xlsx",
                  onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.importVisitors && _ctx.importVisitors(...args)))
                }, null, 544),
                _createVNode(_component_el_button, {
                  type: "default",
                  size: "small",
                  plain: "",
                  onClick: _cache[5] || (_cache[5] = () => _ctx.importFile.click())
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.trans("label.import")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  type: "primary",
                  size: "small",
                  onClick: _ctx.openDialog
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.trans("label.add")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_card, {
          header: `Visitors (${_ctx.visitors.length || 0})`
        }, {
          default: _withCtx(() => [
            (!_ctx.visitors || _ctx.visitors.length == 0)
              ? (_openBlock(), _createBlock(_component_el_empty, { key: 0 }))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visitors, (visitor, index) => {
              return (_openBlock(), _createBlock(_component_el_card, {
                key: index,
                class: _normalizeClass({
						empty: visitor.visitorEmail.trim() === '',
						duplicate:
							_ctx.visitors.filter(
								(item) => item.visitorEmail === visitor.visitorEmail
							).length > 1
					}),
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_row, { gutter: 15 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, {
                        md: 10,
                        lg: 12
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_11, _toDisplayString(visitor.salutation
										? _ctx.trans("label." + visitor.salutation.toLowerCase())
										: "") + " " + _toDisplayString(visitor.lastName) + " " + _toDisplayString(visitor.firstName), 1),
                          _createElementVNode("div", _hoisted_12, _toDisplayString(visitor.contactNo) + ", " + _toDisplayString(visitor.visitorEmail), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_col, {
                        md: 14,
                        lg: 12
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                              _createVNode(_component_el_row, { gutter: 15 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_col, { xl: 12 }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_15, _toDisplayString(visitor.entryType == "Single-entry"
														? _ctx.trans("label.single-entry")
														: _ctx.trans("label.1day")), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_el_col, { xl: 12 }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_16, [
                                        _createTextVNode(_toDisplayString(_ctx.trans("label.verification")) + ": ", 1),
                                        (visitor.status === 5)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              _createTextVNode(_toDisplayString(_ctx.trans("label.yes")), 1)
                                            ], 64))
                                          : _createCommentVNode("", true),
                                        (visitor.status === 1)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                              _createTextVNode(_toDisplayString(_ctx.trans("label.no")), 1)
                                            ], 64))
                                          : _createCommentVNode("", true),
                                        _createTextVNode(", " + _toDisplayString(_ctx.trans("label.alert")) + ": ", 1),
                                        (visitor.alert === 1)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                              _createTextVNode(_toDisplayString(_ctx.trans("label.yes")), 1)
                                            ], 64))
                                          : _createCommentVNode("", true),
                                        (visitor.alert === 0)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                              _createTextVNode(_toDisplayString(_ctx.trans("label.no")), 1)
                                            ], 64))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.trans("label.entry-time")) + ": " + _toDisplayString(visitor.entryTime || " - "), 1)
                            ]),
                            (!_ctx.view)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    size: "small",
                                    onClick: ($event: any) => (_ctx.editVisitor(visitor, index))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.trans("label.edit")), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]),
                                  _createVNode(_component_el_button, {
                                    type: "danger",
                                    size: "small",
                                    onClick: ($event: any) => (_ctx.removeVisitor(index))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.trans("label.remove")), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["class"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["header"]),
        (!_ctx.view)
          ? (_openBlock(), _createBlock(_component_el_dialog, {
              key: 1,
              modelValue: _ctx.showDialog,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.showDialog) = $event)),
              title: 
					_ctx.trans(_ctx.editingIdx == -1 ? 'label.create-new' : 'label.edit') +
					' ' +
					_ctx.trans('label.visitor')
				,
              "before-close": _ctx.handleDialogClose
            }, {
              footer: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "info",
                  size: "small",
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.resetVisitor())),
                  style: {"width":"140px","max-width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.trans("label.reset")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  type: "warning",
                  size: "small",
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.addVisitor())),
                  style: {"width":"140px","max-width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.trans("label.save")), 1)
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_row, { gutter: 15 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { lg: 24 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_row, { gutter: 15 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, {
                              xs: 24,
                              sm: 4
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_19, [
                                  _createVNode(_component_el_form_item, {
                                    prop: "salutation",
                                    label: _ctx.trans('label.salutation')
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_select, {
                                        modelValue: _ctx.model.salutation,
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.model.salutation) = $event)),
                                        size: "small",
                                        "automatic-dropdown": false
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_option, {
                                            label: _ctx.trans('label.mr'),
                                            value: "Mr"
                                          }, null, 8, ["label"]),
                                          _createVNode(_component_el_option, {
                                            label: _ctx.trans('label.ms'),
                                            value: "Ms"
                                          }, null, 8, ["label"]),
                                          _createVNode(_component_el_option, {
                                            label: _ctx.trans('label.mrs'),
                                            value: "Mrs"
                                          }, null, 8, ["label"]),
                                          _createVNode(_component_el_option, {
                                            label: _ctx.trans('label.miss'),
                                            value: "Miss"
                                          }, null, 8, ["label"]),
                                          _createVNode(_component_el_option, {
                                            label: _ctx.trans('label.prof'),
                                            value: "Prof"
                                          }, null, 8, ["label"]),
                                          _createVNode(_component_el_option, {
                                            label: _ctx.trans('label.dr'),
                                            value: "Dr"
                                          }, null, 8, ["label"])
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }, 8, ["label"])
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, {
                              xs: 24,
                              sm: 10
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_20, [
                                  _createVNode(_component_el_form_item, {
                                    prop: "lastName",
                                    label: _ctx.trans('label.last-name'),
                                    rules: {
											required: true,
											message: _ctx.trans(
												'message.field_require',
												_ctx.trans('label.last-name')
											)
										}
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: _ctx.model.lastName,
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.model.lastName) = $event)),
                                        size: "small",
                                        maxlength: "50",
                                        "show-word-limit": ""
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }, 8, ["label", "rules"])
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, {
                              xs: 24,
                              sm: 10
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_21, [
                                  _createVNode(_component_el_form_item, {
                                    prop: "firstName",
                                    label: _ctx.trans('label.first-name')
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: _ctx.model.firstName,
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.model.firstName) = $event)),
                                        size: "small",
                                        maxlength: "50",
                                        "show-word-limit": ""
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }, 8, ["label"])
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { lg: 24 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_row, { gutter: 15 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, {
                              xs: 24,
                              sm: 12
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_22, [
                                  _createVNode(_component_el_form_item, {
                                    prop: "contactNo",
                                    label: _ctx.trans('label.contact-no'),
                                    rules: [
											{
												required: true,
												message: _ctx.trans(
													'message.no_field_require',
													_ctx.trans('label.contact-no')
												),
												min: 8
											},
											{ validator: _ctx.checkPhone }
										]
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: _ctx.model.contactNo,
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.model.contactNo) = $event)),
                                        size: "small",
                                        maxlength: "20",
                                        "show-word-limit": ""
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }, 8, ["label", "rules"])
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, {
                              xs: 24,
                              sm: 12
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_23, [
                                  _createVNode(_component_el_form_item, {
                                    prop: "visitorEmail",
                                    label: _ctx.trans('label.email'),
                                    rules: [
											{
												type: 'email',
												required: true,
												message: _ctx.trans(
													'message.field_not-email',
													_ctx.trans('label.email')
												)
											},
											{ validator: _ctx.checkEmail }
										]
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: _ctx.model.visitorEmail,
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.model.visitorEmail) = $event)),
                                        size: "small",
                                        maxlength: "100",
                                        "show-word-limit": ""
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }, 8, ["label", "rules"])
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, {
                      xs: 24,
                      sm: 8
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_24, [
                          _createVNode(_component_el_form_item, {
                            prop: "entryType",
                            label: _ctx.trans('label.entry-type')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.model.entryType,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.model.entryType) = $event)),
                                size: "small",
                                "automatic-dropdown": false
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, {
                                    value: "Single-entry",
                                    label: _ctx.trans('label.single-entry')
                                  }, null, 8, ["label"]),
                                  _createVNode(_component_el_option, {
                                    value: "1-Day",
                                    label: _ctx.trans('label.1day')
                                  }, null, 8, ["label"])
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, {
                      xs: 24,
                      sm: 16
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_row, { gutter: 15 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_25, [
                                  _createVNode(_component_el_form_item, {
                                    prop: "status",
                                    label: _ctx.trans('label.verification')
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_select, {
                                        modelValue: _ctx.model.status,
                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.model.status) = $event)),
                                        size: "small",
                                        "automatic-dropdown": false
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_option, {
                                            label: _ctx.trans('label.yes'),
                                            value: 5
                                          }, null, 8, ["label"]),
                                          _createVNode(_component_el_option, {
                                            label: _ctx.trans('label.no'),
                                            value: 1
                                          }, null, 8, ["label"])
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }, 8, ["label"])
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_26, [
                                  _createVNode(_component_el_form_item, {
                                    prop: "alert",
                                    label: _ctx.trans('label.alert')
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_select, {
                                        modelValue: _ctx.model.alert,
                                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.model.alert) = $event)),
                                        size: "small",
                                        "automatic-dropdown": false
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_option, {
                                            label: _ctx.trans('label.yes'),
                                            value: 1
                                          }, null, 8, ["label"]),
                                          _createVNode(_component_el_option, {
                                            label: _ctx.trans('label.no'),
                                            value: 0
                                          }, null, 8, ["label"])
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }, 8, ["label"])
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue", "title", "before-close"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["model", "disabled"]))
}